import React from 'react';
import { Col, Form, FormGroup, Label, Input, ModalBody, Row, FormFeedback, ModalFooter, Button, FormText } from "reactstrap";
import Select from 'react-select';

export const FormWSSanitary = (props) => {
    const {
        closeDialog, loading, handleInputChange, validaciones, name_ws, id_type_sample, list_determinations, datadeterminations,
        methodAction, button, handleUpdateValues, datatypesamples, handleSelectValues, formValues
    } = props;
    console.log(formValues, "formValues");
    const {
        name_ws_valid,
        id_type_sample_valid,
        list_determinations_valid

    } = validaciones

    return (
        <Form className='' role="form" onSubmit={methodAction}>
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label className='label-admision'>NOMBRE DE LA HOJA DE TRABAJO: <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            className="input-admision"
                            type='text'
                            name="name_ws"
                            onChange={handleInputChange}
                            value={formValues.name_ws}
                            autoComplete="off"
                            invalid={name_ws_valid}
                        />
                        <FormFeedback>Minimo 3 caracteres</FormFeedback>
                    </FormGroup>
                </Col>

                <Col md="12">
                    <Label className='label-admision'>TIPO DE MUESTRA: <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <FormGroup>
                        <select
                            // className="input-admision"
                            className="form-control input-admision"
                            name="id_type_sample"
                            value={formValues.id_type_sample}
                            onChange={handleInputChange}
                            invalid={list_determinations_valid}
                        >
                            <option value={0}>Selecciona una opción</option>
                            {
                                datatypesamples.map(element => (
                                    <option key={element.value} value={element.value}>
                                        {element.label}
                                    </option>
                                ))
                            }
                        </select>
                        <FormFeedback>Selecciones un tipo de muestra</FormFeedback>


                    </FormGroup>
                </Col>

                <Col sm="12">
                    <Label className='label-admision'>EXAMENES:</Label>
                    <FormGroup>
                        <Select
                            isMulti
                            name="list_determinations"
                            value={formValues.list_determinations}
                            options={datadeterminations}
                            onChange={(e) => handleSelectValues(e, "list_determinations")}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999999 }) }}
                            classNamePrefix="input-admision"
                            invalid={id_type_sample_valid}
                            placeholder="Selecciona una o varias opciones"
                            noOptionsMessage={() => "Sin opciones"}
                            isSearchable={true}
                        />
   
                        <FormFeedback>Selecciones mínimo una determinación</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>
            <ModalFooter>
                <Button color="primary" type="submit" size='sm' className={loading ? "disabled progress-bar-animated progresss-bar-striped" : ""}>
                    {button}
                </Button>
                <Button size="sm" color='danger' type='button' onClick={closeDialog}>
                    Cancelar
                </Button>
            </ModalFooter>
        </Form>
    )
}